<template>
  <div class="panel-list">
    <span class="panel-list__name">{{ listGroup.model.name }}</span>
    <div class="panel-list__items-wrap">
      <template v-if="scrollable">
        <virtual-list
          ref="virtualList"
          :is-pinned="true"
          :size="42"
          :remain="12"
          :data-source="listGroup.children"
        >
          <panel-item
            ref="item"
            v-for="item in listGroup.children"
            @click.native="selectItem(item, $event)"
            :is-selected="currentSelectedItem == item"
            :name="item.model.name"
            :description="item.model.description"
            :key="item.model.id"
            :is-locked="locked"
            :has-children="item.hasChildren()"
          >
            <span v-html="item.model.name"></span>
          </panel-item>
        </virtual-list>
      </template>
      <panel-item
        v-else
        ref="item"
        v-for="item in listGroup.children"
        @click.native="selectItem(item, $event)"
        :is-selected="currentSelectedItem == item"
        :name="item.model.name"
        :description="item.model.description"
        :key="item.model.id"
        :path="item.model.path"
        :is-locked="locked"
        :has-children="item.hasChildren()"
      >
        <span v-html="item.model.name"></span>
      </panel-item>
    </div>
  </div>
</template>

<script>
  import PanelItem from './PanelItem.vue'
  import attributeTypes from '@/appComponents/workbench/attributePanel/services/attributeType'
  import ScrollPanel from '@/components/common/scrollPanel'
  import VirtualList from '@/components/common/virtualScrollList'
  import { createPopover, PopoverFactory, popoverTypes } from '@/components/common/popover'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      PanelItem,
      ScrollPanel,
      VirtualList,
    },
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      listGroup: {
        type: Object,
        required: true,
      },
      advertiser: {
        type: Object,
        required: true,
      },
      locked: {
        type: Boolean,
        default: false,
      },
      selectedValues: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        currentSelectedItem: null,
        currentAttributePopover: null,
        scrollPositionMap: new WeakMap(),
      }
    },
    methods: {
      selectItem(item, event) {
        // onSelect is when an attribute is selected this will ultimately add an attribute to the target definition
        if (this.locked) {
          return
        }
        if (item.model.type && item.model.type !== 'boolean') {
          this.selectOptionableItem(item, event)
        } else if (!item.children || item.children.length === 0) {
          let i = cloneDeep(item.model)
          this.onSelect(i, event)
        } else {
          // just emit that the item was selected
          if (this.scrollable) {
            this.scrollPositionMap.set(this.listGroup, this.$refs.virtualList.getScrollTop())
          }
          if (item.children && item.children.length > 0) {
            this.$emit('expandNode', { item, event })
          }
        }
      },
      selectOptionableItem(item, event) {
        let attribute = item.model
        if (attribute.type === attributeTypes.BOOLEAN) {
          this.onSelect(cloneDeep(attribute))
        } else {
          this.currentSelectedItem = item
          // not sure about the attributes
          // have to look into the selectedValues
          let attributes = this.selectedValues
          if (attribute.traitId) {
            let values = attributes ? attributes[item.model.traitId] : attributes
            this.currentAttributePopover = PopoverFactory.createSelectableBoxOffClickDeadline({
              attribute: item.model,
              values: values,
              direction: 'right',
              parent: event.target,
            })
          } else {
            this.currentAttributePopover = createPopover({
              attribute,
              direction: 'right',
              parent: event.target,
              type: popoverTypes.ATTRIBUTE,
            })
          }
          this.currentAttributePopover.$on('select', this.onSelect)
          this.currentAttributePopover.$on('dismiss', this.deselectCurrentSelectedItem)
        }
      },
      deselectCurrentSelectedItem() {
        this.currentAttributePopover = null
        this.currentSelectedItem = null
      },
      onSelect(item, event) {
        this.$emit('onSelect', { item, event })
      },
    },
    watch: {
      /**
       * Set the list scroll position to 0 when listGroup changes
       */
      listGroup(newValue) {
        if (this.scrollable) {
          this.$nextTick(() => {
            this.$refs.virtualList.scrollTo(this.scrollPositionMap.get(newValue) || 0)
            // delete the scroll position for the list group we are displaying so
            // we don't record it indefinitely.
            this.scrollPositionMap.delete(newValue)
          })
        }
      },
    },
  }
</script>

<style lang="scss">
  .panel-list {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__items-wrap {
      position: relative;
      height: 100%;
    }

    &__items {
      padding: 0;
      margin: 0;
    }

    &__name {
      display: block;
      margin-bottom: rem(5);
      color: color(grays, extra-light);
      font-size: rem(12);
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>



// WEBPACK FOOTER //
// List.vue?0c9c3692